import React from 'react';
import { Link } from 'react-router-dom';
import { Video, Calendar } from 'lucide-react';
import { Button } from '../ui/button';

const CTASection = () => {
  return (
    <section className="py-10 sm:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-2xl sm:rounded-3xl bg-gradient-to-r from-teal-400 via-teal-500 to-cyan-500 p-8 sm:p-12 lg:p-16">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full -translate-y-1/2 translate-x-1/2" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-white rounded-full translate-y-1/2 -translate-x-1/2" />
          </div>

          <div className="relative text-center">
            <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 sm:mb-4">
              Your Kidney Health Is Our Priority.
            </h2>
            <p className="text-sm sm:text-lg text-teal-100 mb-6 sm:mb-8">
              Pain ko ignore mat karo. Right doctor, right time.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
              <Link to="/contact">
                <Button className="w-full sm:w-auto bg-white text-teal-600 hover:bg-gray-100 rounded-full px-6 sm:px-8 py-4 sm:py-6 text-sm sm:text-base font-medium flex items-center justify-center gap-2 shadow-lg">
                  Consult Now
                  <Video className="w-4 h-4 sm:w-5 sm:h-5" />
                </Button>
              </Link>
              <Link to="/book-consultation">
                <Button className="w-full sm:w-auto bg-teal-600 text-white hover:bg-teal-700 rounded-full px-6 sm:px-8 py-4 sm:py-6 text-sm sm:text-base font-medium flex items-center justify-center gap-2 shadow-lg">
                  <Calendar className="w-4 h-4 sm:w-5 sm:h-5" />
                  Book Appointment
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
